import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <Link to="/" className="footer__link">Saundarryam</Link>
        <span className="footer__divider">·</span>
        <Link to="/contact" className="footer__link">Contact</Link>
        <span className="footer__divider">·</span>
        <Link to="/about" className="footer__link">About</Link>
        <span className="footer__divider">·</span>
        <span className="footer__copy">© 2020 saundarryam.com</span>
      </div>
    </footer>
  );
}

export default Footer;